import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { AppNotification } from '../types/notifications';
import { notificationService } from '../services/notificationService';

interface UseUserNotificationsOptions {
  onlyUnread?: boolean;
  maxResults?: number;
}

export const useUserNotifications = (
  options: UseUserNotificationsOptions = {}
): {
  notifications: AppNotification[];
  loading: boolean;
} => {
  const onlyUnread = options.onlyUnread;
  const maxResults = options.maxResults;
  const { currentUser } = useAuth();
  const [notifications, setNotifications] = useState<AppNotification[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!currentUser?.uid) {
      setNotifications([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    const unsubscribe = notificationService.subscribeToUserNotifications(
      currentUser.uid,
      (data) => {
        setNotifications(data);
        setLoading(false);
      },
      (error) => {
        console.error('Notifications subscription error:', error);
        setNotifications([]);
        setLoading(false);
      },
      { onlyUnread, maxResults }
    );

    return () => unsubscribe();
  }, [currentUser?.uid, onlyUnread, maxResults]);

  return { notifications, loading };
};
